module.exports = __webpack_public_path__ + "img/VALOR_RESPETO1.724b236e.png";